var render, staticRenderFns
import script from "./paymentMixin.vue?vue&type=script&lang=js"
export * from "./paymentMixin.vue?vue&type=script&lang=js"
import style0 from "./paymentMixin.vue?vue&type=style&index=0&id=25656428&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25656428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25656428')) {
      api.createRecord('25656428', component.options)
    } else {
      api.reload('25656428', component.options)
    }
    
  }
}
component.options.__file = "src/components/consultant/profile/payment/mixin/paymentMixin.vue"
export default component.exports